export default __webpack_public_path__ + "static/media/pb.cab2b94a.png";